import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  ropEnabledData: {},
  isLoading: false,
  error: {},
  hasData: false,
  ropStatus: {
    status: false,
    message: ""
  }
};
const ropEnableDataSlice = createSlice({
  name: "ropEnable",
  initialState,
  reducers: {
    getRopEnableDataPending: state => {
      state.isLoading = true;
    },
    getRopEnableSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.ropEnabledData = action.payload;
      state.ropStatus.status = true;
      state.error = {};
    },
    getRopEnableFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload.response.data;
      state.ropEnabledData = {};
      state.ropStatus.status = false;
    },
    resetRopEnableData: state => {
      state.error = {};
      state.isLoading = false;
      state.hasData = false;
      state.ropEnabledData = {};
    }
  }
});
export const {
  getRopEnableDataPending,
  getRopEnableSuccess,
  getRopEnableFailure,
  resetRopEnableData
} = ropEnableDataSlice.actions;
export default ropEnableDataSlice.reducer;